module.exports = __webpack_public_path__ + "img/Accountor-42-lowres.769b49c4.jpg";